import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import InputField from '../../../shared/form-elements/input';

import './change-password.less';

const Form  = (props) => {
	const {
		handleSubmit,
		updatePassword,
		intl
	} = props;

	return (
		<form action="#"
			className="profile__password half-width clearfix"
			onSubmit={handleSubmit(formData => updatePassword(formData))}
		>
			<div className="profile-wrap__form-field clearfix">
				<div className="profile-wrap__position-left">
					<Field name="old_password"
						placeholder={intl('Старый пароль')}
						component={InputField}
						shouldDisable={false}
						type="password"
					/>
				</div>

			</div>

			<div className="profile-wrap__form-field clearfix">
				<div className="profile-wrap__position-left">
					<Field name="new_password"
						placeholder={intl('Новый пароль')}
						component={InputField}
						shouldDisable={false}
						type="password"
					/>
				</div>

				<div className="profile-wrap__position-left">
					<i className="profile-wrap__change-info font-times-new-roman-italic">
						{intl('Пароль должен состоять не менее чем из шести символов')}
					</i>
				</div>
			</div>

			<div className="profile-wrap__form-field clearfix">
				<div className="profile-wrap__position-left">
					<Field name="new_password_confirmation"
						placeholder={intl('Повторите новый пароль')}
						component={InputField}
						shouldDisable={false}
						type="password"
					/>
				</div>

				<div className="profile-wrap__position-left">
					<i className="profile-wrap__change-info font-times-new-roman-italic">
						<span>{intl('Пароли должны совпадать')}</span>
					</i>
				</div>
			</div>

			<button className="button yellow-btn profile-change-btn font-proxima-nova-semibold">
				{intl('Изменить данные')}
			</button>

		</form>
	);
};

Form.propTypes = {
	handleSubmit: PropTypes.func,
	updatePassword: PropTypes.func,
	intl: PropTypes.func
};

export default reduxForm({
	form: 'profileChangePasswordForm'
})(Form);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/profile/components/forms/change-password.js